module.exports = __webpack_public_path__ + "img/drachenmakifrontal.a6dd756d.jpg";